<template>
	<Col>
		<SharedUserItem
			insideGroup
			:key="userId"
			:disabled="isLocked"
			:workflow="workflow"
			class="share-list-item"
			v-for="userId in group.users"
			:user="teamMemberByUserId(userId)"
			:userShareData="getUserShareData(userId)"
			:disabledExplanation="disabledExplanation"
			:hideVisibilityStatus="hideVisibilityStatus"
		/>
		<SharedGroupItem
			:group="subGroup"
			:key="subGroup.id"
			:workflow="workflow"
			:sharedData="sharedData"
			isNestedInsideAnotherGroup
			v-for="subGroup in subGroups"
			:usersSharedData="usersSharedData"
			:nestedLevelIndex="nestedLevelIndex + 1"
			:hideVisibilityStatus="hideVisibilityStatus"
		/>
	</Col>
</template>
<script>
import { mapGettersShorthand } from '@/store/utils/mappers';
import { groupById } from '@/store/modules/accountGroups/getters';
import { teamMemberByUserId } from '@/store/modules/account/getters';
import SharedUserItem from '@/components/dialogs/ShareFeatureDialog/ExistingShareList/SharedUserItem.vue';
export default {
	name: 'SharedGroupItemContent',
	components: {
		SharedUserItem,
		SharedGroupItem: () => import('@/components/dialogs/ShareFeatureDialog/ExistingShareList/SharedGroupItem.vue'), //prevent circular dependency
	},
	props: {
		group: { type: Object },
		workflow: { type: Object },
		sharedData: { type: Array },
		isLocked: { type: Boolean },
		isVisible: { type: Boolean },
		usersSharedData: { type: Array },
		nestedLevelIndex: { type: Number },
		hideVisibilityStatus: { type: Boolean },
	},
	computed: {
		...mapGettersShorthand({ teamMemberByUserId, groupById }),
		disabledExplanation() {
			return `Can't change visibility for specific user, when visibility is locked for all users`;
		},
		subGroupsIds() {
			return this.group.sub_groups;
		},
		subGroups() {
			return this.subGroupsIds.map((id) => this.groupById(id));
		},
	},
	methods: {
		getUserShareData(userId) {
			return this.usersSharedData?.find((u) => u.id === userId) || { id: userId, is_on: true }; // the fallback is for users inside everyone group. shouldn't happen to others
		},
	},
};
</script>

<style scoped lang="scss"></style>
